import { useState, useEffect } from 'react';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    setShowWarningModal(true);
  };

  const handleAgreeAndProceed = () => {
    setShowWarningModal(false);
    window.open('https://wa.me/5519988604840?text=Olá,%20preciso%20de%20um%20guincho%20urgente!%20Qual%20o%20guincho%20mais%20próximo%20da%20minha%20localização?', '_blank');
  };

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    try {
      await fetch('https://readdy.ai/api/form/d5i0fujgekujqjrtsrpg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });
      setShowSuccessMessage(true);
      form.reset();
      setTimeout(() => setShowSuccessMessage(false), 5000);
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white font-['Inter',sans-serif]">

      {/* Modal de Aviso */}
      {showWarningModal && (
        <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center p-0 sm:p-4">
          <div className="absolute inset-0 bg-black/70" onClick={() => setShowWarningModal(false)}></div>
          <div className="relative bg-white w-full sm:w-auto sm:min-w-[420px] sm:max-w-md rounded-t-3xl sm:rounded-2xl shadow-2xl flex flex-col"
            style={{ maxHeight: '88vh' }}>
            
            {/* Indicador de arraste (mobile) */}
            <div className="flex justify-center pt-3 pb-1 sm:hidden flex-shrink-0">
              <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
            </div>

            {/* Cabeçalho vermelho */}
            <div className="bg-red-600 px-5 py-4 flex items-center gap-3 flex-shrink-0 sm:rounded-t-2xl">
              <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                <i className="ri-alert-fill text-white text-xl"></i>
              </div>
              <div>
                <h3 className="text-white font-extrabold text-sm leading-tight">⚠️ ATENÇÃO IMPORTANTE</h3>
                <p className="text-red-100 text-xs mt-0.5">Leia antes de prosseguir</p>
              </div>
            </div>

            {/* Corpo com scroll */}
            <div className="px-4 py-4 overflow-y-auto flex-1 overscroll-contain">
              <p className="text-gray-800 font-semibold text-sm mb-3 leading-relaxed">
                Por questões de <strong className="text-red-600">segurança e proteção</strong> da nossa equipe e dos nossos clientes, informamos que:
              </p>

              <div className="space-y-2 mb-4">
                <div className="flex items-start gap-2 bg-red-50 border border-red-100 rounded-xl p-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-error-warning-fill text-red-500 text-base"></i>
                  </div>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    <strong>Registramos ocorrências de golpes na região</strong> — chamadas falsas, clientes que acionam o guincho e abandonam o local antes da chegada, causando prejuízo à equipe.
                  </p>
                </div>

                <div className="flex items-start gap-2 bg-red-50 border border-red-100 rounded-xl p-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-shield-cross-fill text-red-500 text-base"></i>
                  </div>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    <strong>Casos de roubos a guinchos</strong> foram registrados na área, colocando em risco a segurança dos nossos motoristas durante o atendimento.
                  </p>
                </div>

                <div className="flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-xl p-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-bank-card-fill text-amber-500 text-base"></i>
                  </div>
                  <p className="text-gray-700 text-xs leading-relaxed">
                    <strong>Por isso, exigimos pagamento via PIX no ato do chamado</strong>, antes do deslocamento do guincho. Isso garante a segurança de todos e a seriedade do atendimento.
                  </p>
                </div>
              </div>

              <div className="bg-[#1A2332] rounded-xl px-4 py-3 text-center">
                <p className="text-white text-xs font-semibold leading-relaxed">
                  ✅ Ao clicar em <strong className="text-[#FFD700]">"Concordo e Quero Chamar"</strong>, você confirma que está ciente e concorda com o pagamento via PIX no Ato do chamado
                </p>
              </div>
            </div>

            {/* Botões fixos no rodapé */}
            <div className="flex flex-col gap-2 px-4 pb-6 pt-3 flex-shrink-0 border-t border-gray-100">
              <button
                onClick={handleAgreeAndProceed}
                className="w-full bg-[#25D366] text-white py-4 rounded-xl font-bold text-sm hover:bg-[#20BD5A] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 shadow-lg"
              >
                <i className="ri-whatsapp-fill text-xl"></i>
                Concordo e Quero Chamar
              </button>
              <button
                onClick={() => setShowWarningModal(false)}
                className="w-full border-2 border-gray-300 text-gray-600 py-3 rounded-xl font-semibold text-sm hover:bg-gray-50 transition-all cursor-pointer whitespace-nowrap"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header/Navbar */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <nav className="container mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/58d736f6-4017-4859-9277-896136227522.png" 
              alt="Guincho Brasil 24h Logo" 
              className="h-10 md:h-12 w-auto"
            />
          </div>
          <div className="hidden lg:flex items-center gap-8">
            <a href="#cobertura" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FFD700]' : 'text-white hover:text-[#FFD700]'}`}>
              Cobertura
            </a>
            <a href="#servicos" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FFD700]' : 'text-white hover:text-[#FFD700]'}`}>
              Serviços
            </a>
            <a href="#depoimentos" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FFD700]' : 'text-white hover:text-[#FFD700]'}`}>
              Depoimentos
            </a>
            <a href="#contato" className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-[#FFD700]' : 'text-white hover:text-[#FFD700]'}`}>
              Contato
            </a>
          </div>
          <button 
            onClick={handleWhatsAppClick}
            className="bg-[#25D366] text-white px-4 md:px-6 py-2 md:py-2.5 rounded-full font-semibold text-xs md:text-sm hover:bg-[#20BD5A] transition-all hover:scale-105 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-base md:text-lg"></i>
            <span className="hidden sm:inline">Chamar Agora</span>
            <span className="sm:hidden">Chamar</span>
          </button>
        </nav>
      </header>

      {/* Hero Section - Chamada de Socorro 24h */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/a885a46cacbe13ec8aef5e20ba167b41.jpg"
            alt="Rodovia Brasil"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#1A2332]/70 via-[#1A2332]/60 to-[#1A2332]/70"></div>
        </div>
        
        <div className="relative z-10 text-center px-4 w-full py-20">
          <div className="inline-block mb-4 px-3 md:px-4 py-1.5 bg-red-600 rounded-full animate-pulse">
            <span className="text-white text-xs font-bold uppercase tracking-wide">● ONLINE AGORA</span>
          </div>
          
          <h1 className="text-white font-extrabold text-4xl sm:text-5xl md:text-6xl lg:text-8xl mb-3 tracking-tight leading-tight">
            GUINCHO 24 HORAS
          </h1>
          <p className="text-[#FFD700] font-light italic text-xl sm:text-2xl md:text-3xl lg:text-5xl mb-6">
            Em Todo o Brasil
          </p>
          
          <div className="flex items-center justify-center gap-3 md:gap-4 mb-8 md:mb-10 text-white/90 text-xs sm:text-sm md:text-lg lg:text-xl flex-wrap px-4">
            <span className="flex items-center gap-1 md:gap-2">
              <span className="text-[#FFD700]">●</span> Atendimento Imediato
            </span>
            <span className="flex items-center gap-1 md:gap-2">
              <span className="text-[#FFD700]">●</span> Guincho Mais Próximo
            </span>
            <span className="flex items-center gap-1 md:gap-2">
              <span className="text-[#FFD700]">●</span> Cobertura Nacional
            </span>
          </div>
          
          <button 
            onClick={handleWhatsAppClick}
            className="relative inline-flex items-center gap-2 md:gap-3 bg-[#25D366] text-white px-6 sm:px-10 md:px-14 py-4 md:py-6 rounded-full font-bold text-sm sm:text-base md:text-xl hover:bg-[#20BD5A] transition-all hover:scale-105 shadow-2xl animate-pulse cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-fill text-xl md:text-3xl"></i>
            <span className="hidden sm:inline">CHAMAR GUINCHO AGORA</span>
            <span className="sm:hidden">CHAMAR AGORA</span>
            <i className="ri-arrow-right-line text-lg md:text-2xl"></i>
          </button>
          
          <div className="mt-4 md:mt-6 bg-[#FFD700]/20 backdrop-blur-sm border-2 border-[#FFD700] rounded-2xl px-4 md:px-6 py-3 md:py-4 inline-block">
            <p className="text-white font-bold text-base sm:text-lg md:text-2xl flex items-center justify-center gap-2 md:gap-3">
              <i className="ri-map-pin-time-line text-[#FFD700] text-xl md:text-3xl"></i>
              <span>Guincho a <span className="text-[#FFD700]">10 minutos</span> de você!</span>
            </p>
          </div>
          
          <p className="mt-6 text-white/80 text-xs md:text-sm flex items-center justify-center gap-2">
            <i className="ri-time-line"></i>
            Resposta em menos de 2 minutos
          </p>
        </div>
      </section>

      {/* Seção de Cobertura - Mapa */}
      <section id="cobertura" className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="grid md:grid-cols-5 gap-6 md:gap-8 items-center">
            {/* Coluna Esquerda - Informações */}
            <div className="md:col-span-2 bg-[#FFF9E6] rounded-2xl md:rounded-3xl p-6 md:p-10">
              <div className="inline-block bg-white px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-4 md:mb-6">
                <span className="text-[#1A2332] text-xs font-bold uppercase tracking-wide">NOSSA COBERTURA</span>
              </div>
              
              <h2 className="text-gray-700 text-lg md:text-2xl mb-2">Atendemos em</h2>
              <h3 className="text-[#1A2332] text-3xl md:text-5xl font-extrabold mb-6 md:mb-8">Todo o Brasil</h3>
              
              <div className="space-y-4 md:space-y-5 mb-6 md:mb-8">
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-base md:text-lg font-medium">Todas as Capitais</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-base md:text-lg font-medium">Interior de Todos os Estados</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-base md:text-lg font-medium">Rodovias Federais e Estaduais</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 md:w-6 md:h-6 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-xs md:text-sm"></i>
                  </div>
                  <span className="text-gray-700 text-base md:text-lg font-medium">Rede Nacional de Parceiros</span>
                </div>
              </div>
              
              <div className="bg-white border-2 border-dashed border-[#FFD700] rounded-xl md:rounded-2xl p-4 md:p-6 text-center">
                <div className="flex items-center justify-center gap-3">
                  <i className="ri-map-pin-line text-[#FFD700] text-2xl md:text-3xl"></i>
                  <div className="text-left">
                    <p className="text-gray-600 text-xs md:text-sm">Conectamos você ao:</p>
                    <p className="text-[#1A2332] text-xl md:text-2xl font-bold">Guincho Mais Próximo</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Coluna Direita - Mapa */}
            <div className="md:col-span-3">
              <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31827990.13478!2d-55.491477!3d-14.235004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9c59c7ebcc28cf%3A0x295a1506f2293e63!2sBrasil!5e0!3m2!1spt-BR!2sbr!4v1234567890123!5m2!1spt-BR!2sbr"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mapa de Cobertura Brasil"
                  className="md:h-[500px]"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Serviços */}
      <section id="servicos" className="py-12 md:py-20 bg-white">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-16">
            <p className="text-gray-500 text-xs md:text-sm uppercase tracking-wider mb-3">POR QUE NOS ESCOLHER</p>
            <h2 className="text-[#1A2332] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              Serviço Profissional<br />Disponível 24/7
            </h2>
          </div>
          
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
            {/* Card 1 */}
            <div className="bg-[#F8F9FA] rounded-xl md:rounded-2xl p-6 md:p-10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-phone-line text-[#1A2332] text-4xl md:text-5xl"></i>
              </div>
              <h3 className="text-[#1A2332] text-xl md:text-2xl font-bold mb-3 md:mb-4">Atendimento Imediato</h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Nossa central funciona 24 horas por dia, 7 dias por semana. Atendemos sua chamada em segundos e conectamos você ao guincho mais próximo da sua localização.
              </p>
            </div>
            
            {/* Card 2 */}
            <div className="bg-[#F8F9FA] rounded-xl md:rounded-2xl p-6 md:p-10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-map-pin-user-line text-[#FFD700] text-4xl md:text-5xl"></i>
              </div>
              <h3 className="text-[#1A2332] text-xl md:text-2xl font-bold mb-3 md:mb-4">Guincho Mais Próximo</h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Através da nossa rede nacional de parceiros certificados, localizamos e despachamos o guincho mais próximo de você, garantindo atendimento rápido em qualquer lugar do Brasil.
              </p>
            </div>
            
            {/* Card 3 */}
            <div className="bg-[#F8F9FA] rounded-xl md:rounded-2xl p-6 md:p-10 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 sm:col-span-2 md:col-span-1">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center mb-4 md:mb-6">
                <i className="ri-shield-check-line text-[#1A2332] text-4xl md:text-5xl"></i>
              </div>
              <h3 className="text-[#1A2332] text-xl md:text-2xl font-bold mb-3 md:mb-4">Seguro e Confiável</h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Todos os nossos parceiros são treinados e certificados. Seu veículo é transportado com total segurança, com seguro completo durante todo o trajeto do reboque.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Depoimentos */}
      <section id="depoimentos" className="py-12 md:py-20 bg-[#FAF8F5]">
        <div className="container mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-16">
            <div className="flex items-center justify-center gap-2 mb-3">
              <span className="w-2 h-2 bg-[#FFD700] rounded-full"></span>
              <p className="text-gray-500 text-xs md:text-sm uppercase tracking-wider">DEPOIMENTOS</p>
            </div>
            <h2 className="text-[#1A2332] text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4">
              O Que Nossos Clientes Dizem
            </h2>
            <p className="text-gray-600 text-base md:text-lg">Mais de 50.000 atendimentos realizados em todo o Brasil</p>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-8">
            {/* Depoimento 1 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Atendimento rápido e eficiente</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Tive um problema na rodovia às 3h da manhã. Liguei e em 25 minutos o guincho mais próximo já estava comigo. Profissionais muito atenciosos e cuidadosos com meu carro. Super recomendo!
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">MC</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Marcos Costa</p>
                  <p className="text-gray-500 text-xs md:text-sm">São Paulo - SP</p>
                </div>
              </div>
            </div>
            
            {/* Depoimento 2 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Salvaram meu dia!</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Estava viajando pelo interior quando meu carro quebrou. O atendimento foi excelente, desde o primeiro contato até a entrega do veículo. Preço justo e serviço de qualidade.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">AS</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Ana Silva</p>
                  <p className="text-gray-500 text-xs md:text-sm">Rio de Janeiro - RJ</p>
                </div>
              </div>
            </div>
            
            {/* Depoimento 3 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Profissionais de confiança</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Já utilizei o serviço 3 vezes em diferentes estados e sempre fui muito bem atendido. Os motoristas são educados, pontuais e cuidadosos. É o guincho que eu sempre recomendo.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">RS</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Roberto Santos</p>
                  <p className="text-gray-500 text-xs md:text-sm">Belo Horizonte - MG</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {/* Depoimento 4 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Melhor custo-benefício</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Pesquisei vários guinchos e este foi o que ofereceu o melhor preço sem perder a qualidade. O guincho chegou rápido, fizeram o serviço com cuidado e ainda me deram dicas sobre meu carro.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">JO</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Juliana Oliveira</p>
                  <p className="text-gray-500 text-xs md:text-sm">Curitiba - PR</p>
                </div>
              </div>
            </div>
            
            {/* Depoimento 5 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Atendimento humanizado</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Estava muito nervosa quando meu carro parou na estrada. A atendente foi super paciente e tranquilizadora. O motorista do guincho mais próximo chegou rápido e me deixou segura durante todo o processo.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">PM</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Paula Mendes</p>
                  <p className="text-gray-500 text-xs md:text-sm">Porto Alegre - RS</p>
                </div>
              </div>
            </div>
            
            {/* Depoimento 6 */}
            <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-all duration-300">
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFD700] text-base md:text-xl"></i>
                ))}
              </div>
              <h4 className="text-[#1A2332] font-bold text-base md:text-lg mb-3 md:mb-4">Sempre disponíveis</h4>
              <p className="text-gray-700 text-xs md:text-sm leading-relaxed mb-6">
                Precisei de guincho num domingo de manhã e eles atenderam prontamente. Não cobram taxa extra por final de semana ou feriado. Serviço honesto e transparente do início ao fim.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
                  <span className="text-[#1A2332] font-bold text-sm md:text-lg">CF</span>
                </div>
                <div>
                  <p className="text-[#1A2332] font-bold text-sm md:text-base">Carlos Ferreira</p>
                  <p className="text-gray-500 text-xs md:text-sm">Brasília - DF</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final - Botão de Ação Imediata */}
      <section className="relative overflow-hidden">
        <div className="grid md:grid-cols-2">
          {/* Lado Esquerdo - Visual */}
          <div className="relative bg-[#FFD700] min-h-[400px] md:min-h-[600px] flex items-end p-8 md:p-12">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20professional%20tow%20truck%20in%20bright%20yellow%20color%2C%20side%20view%20on%20clean%20simple%20background%2C%20high%20quality%20commercial%20photography%2C%20automotive%20service%20vehicle%2C%20detailed%20flatbed%20truck%20with%20hydraulic%20lift%20system%2C%20professional%20lighting%2C%20studio%20quality%20image&width=800&height=600&seq=tow-truck-modern&orientation=landscape"
              alt="Guincho Moderno"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="relative z-10">
              <div className="inline-block bg-white px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-3 md:mb-4">
                <span className="text-[#1A2332] text-xs font-bold uppercase tracking-wide">DISPONÍVEL AGORA</span>
              </div>
              <h2 className="text-[#1A2332] leading-tight">
                <span className="block text-2xl md:text-4xl mb-1">Precisa de</span>
                <span className="block text-4xl md:text-7xl font-bold mb-1">Guincho</span>
                <span className="block text-3xl md:text-6xl font-bold">Agora?</span>
              </h2>
            </div>
          </div>
          
          {/* Lado Direito - Ação */}
          <div className="bg-white min-h-[400px] md:min-h-[600px] flex items-center justify-center p-8 md:p-12">
            <div className="max-w-lg text-center">
              <h2 className="text-[#1A2332] text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight mb-6 md:mb-8">
                Atendimento Rápido<br />24 Horas por Dia
              </h2>
              
              <p className="text-gray-600 text-sm md:text-lg leading-relaxed mb-8 md:mb-12 max-w-md mx-auto">
                Não importa onde você esteja no Brasil, nossa rede de parceiros está pronta para te ajudar. Conectamos você ao guincho mais próximo para atendimento profissional, rápido e seguro.
              </p>
              
              <button 
                onClick={handleWhatsAppClick}
                className="inline-flex items-center gap-2 md:gap-4 bg-[#25D366] text-white px-6 sm:px-10 md:px-14 py-4 md:py-6 rounded-full font-bold text-sm sm:text-base md:text-xl hover:bg-[#20BD5A] transition-all hover:scale-105 shadow-2xl animate-pulse cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-fill text-xl md:text-3xl"></i>
                <span className="hidden sm:inline">CHAMAR NO WHATSAPP AGORA</span>
                <span className="sm:hidden">CHAMAR AGORA</span>
                <i className="ri-arrow-right-line text-lg md:text-2xl"></i>
              </button>
              
              <div className="mb-6 bg-[#FFD700]/10 border-2 border-[#FFD700] rounded-xl px-4 md:px-6 py-2 md:py-3 inline-block">
                <p className="text-[#1A2332] font-bold text-sm md:text-lg flex items-center justify-center gap-2">
                  <i className="ri-map-pin-time-line text-[#FFD700] text-lg md:text-2xl"></i>
                  <span>Guincho a <span className="text-[#FFD700]">10 minutos</span> de você!</span>
                </p>
              </div>
              
              <p className="text-gray-500 text-xs md:text-sm flex items-center justify-center gap-2">
                <i className="ri-time-line"></i>
                Resposta em menos de 2 minutos
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Contato via WhatsApp */}
      <section id="contato" className="py-12 md:py-20 bg-[#F8F9FA]">
        <div className="container mx-auto px-4 md:px-6 max-w-2xl">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="text-[#1A2332] text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4">
              Entre em Contato
            </h2>
            <p className="text-gray-600 text-base md:text-lg">
              Preencha o formulário e conectaremos você ao guincho mais próximo
            </p>
          </div>
          
          <form 
            onSubmit={handleFormSubmit}
            data-readdy-form
            id="contato-guincho"
            className="bg-white rounded-xl md:rounded-2xl shadow-lg p-6 md:p-10"
          >
            <div className="space-y-5 md:space-y-6">
              <div>
                <label htmlFor="nome" className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFD700] transition-all text-sm md:text-base"
                  placeholder="Seu nome"
                />
              </div>
              
              <div>
                <label htmlFor="telefone" className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
                  Telefone *
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFD700] transition-all text-sm md:text-base"
                  placeholder="(11) 99999-9999"
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFD700] transition-all text-sm md:text-base"
                  placeholder="seu@email.com"
                />
              </div>
              
              <div>
                <label htmlFor="localizacao" className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
                  Sua Localização Atual *
                </label>
                <input
                  type="text"
                  id="localizacao"
                  name="localizacao"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFD700] transition-all text-sm md:text-base"
                  placeholder="Cidade, estado ou rodovia"
                />
              </div>
              
              <div>
                <label htmlFor="mensagem" className="block text-gray-700 font-semibold mb-2 text-sm md:text-base">
                  Descreva sua situação *
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FFD700] transition-all resize-none text-sm md:text-base"
                  placeholder="Conte-nos o que aconteceu com seu veículo..."
                ></textarea>
                <p className="text-gray-500 text-xs mt-1">Máximo 500 caracteres</p>
              </div>
              
              <button
                type="submit"
                className="w-full bg-[#1A2332] text-white py-3 md:py-4 rounded-lg font-bold text-base md:text-lg hover:bg-[#2A3342] transition-all hover:scale-[1.02] cursor-pointer whitespace-nowrap"
              >
                Enviar Mensagem
              </button>
            </div>
          </form>
          
          {showSuccessMessage && (
            <div className="mt-6 bg-green-50 border border-green-200 rounded-lg p-4 text-center">
              <p className="text-green-700 font-semibold text-sm md:text-base">✓ Mensagem enviada com sucesso! Entraremos em contato em breve.</p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A2332] text-white">
        <div className="container mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
            {/* Coluna 1 - Logo e Descrição */}
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/58d736f6-4017-4859-9277-896136227522.png" 
                alt="Guincho Brasil 24h" 
                className="h-10 md:h-12 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
                Serviço de guincho profissional disponível 24 horas por dia em todo o Brasil. Conectamos você ao guincho mais próximo para atendimento rápido e seguro.
              </p>
            </div>
            
            {/* Coluna 2 - Contato Rápido */}
            <div>
              <h4 className="text-gray-300 text-xs uppercase tracking-wider mb-4 font-bold">CONTATO RÁPIDO</h4>
              <div className="flex gap-2 mb-3">
                <input
                  type="tel"
                  placeholder="Seu telefone"
                  className="flex-1 bg-transparent border-b border-gray-600 py-2 text-xs md:text-sm focus:outline-none focus:border-[#FFD700] transition-colors"
                />
                <button className="w-10 h-10 bg-[#FFD700] rounded-full flex items-center justify-center hover:bg-[#FFC700] transition-colors cursor-pointer flex-shrink-0">
                  <i className="ri-arrow-right-line text-[#1A2332] text-lg"></i>
                </button>
              </div>
              <p className="text-gray-500 text-xs">
                <a href="tel:+5519988604840" className="hover:text-[#FFD700] transition-colors cursor-pointer">
                  Ligamos em 30 segundos
                </a>
              </p>
            </div>
            
            {/* Coluna 3 - Links Úteis */}
            <div>
              <h4 className="text-gray-300 text-xs uppercase tracking-wider mb-4 font-bold">LINKS ÚTEIS</h4>
              <ul className="space-y-3 md:space-y-4">
                <li>
                  <a href="#cobertura" className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer">
                    Áreas de Atendimento
                  </a>
                </li>
                <li>
                  <a href="#servicos" className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer">
                    Tipos de Guincho
                  </a>
                </li>
                <li>
                  <a href="#depoimentos" className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer">
                    Perguntas Frequentes
                  </a>
                </li>
              </ul>
            </div>
            
            {/* Coluna 4 - Redes Sociais */}
            <div>
              <h4 className="text-gray-300 text-xs uppercase tracking-wider mb-4 font-bold">REDES SOCIAIS</h4>
              <ul className="space-y-3 md:space-y-4">
                <li>
                  <a 
                    href="https://wa.me/5519988604840" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-whatsapp-line"></i>
                    WhatsApp Business
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-instagram-line"></i>
                    Instagram
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white text-xs md:text-sm hover:text-[#FFD700] transition-colors cursor-pointer flex items-center gap-2">
                    <i className="ri-facebook-line"></i>
                    Facebook
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        {/* Área de Branding */}
        <div className="bg-[#0F1419] py-8 md:py-12 overflow-hidden">
          <div className="container mx-auto px-4 md:px-6">
            <h3 className="text-[#E8DCC4] text-4xl sm:text-5xl md:text-6xl lg:text-8xl font-bold text-center tracking-tight" style={{ fontFamily: 'Arial Black, sans-serif' }}>
              GUINCHO BRASIL 24H
            </h3>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="bg-[#0A0D11] py-4 md:py-6">
          <div className="container mx-auto px-4 md:px-6">
            <div className="flex flex-col md:flex-row justify-between items-center gap-3 md:gap-4 text-gray-500 text-xs md:text-sm">
              <p>© 2024 Guincho Brasil 24h. Todos os direitos reservados.</p>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-[#FFD700] transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
